"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubNavItem = exports.SubMenu = exports.ALIGNMENT = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _theming = _interopRequireDefault(require("../../../utils/theming"));

var ALIGNMENT = {
  LEFT: 'left',
  RIGHT: 'right'
};
exports.ALIGNMENT = ALIGNMENT;
var SubMenu = (0, _theming.default)('ul')(function (_ref) {
  var _ref2;

  var theme = _ref.theme,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? ALIGNMENT.LEFT : _ref$align;
  return _ref2 = {
    overflow: 'hidden',
    backgroundColor: theme.palette.core1_100,
    position: 'absolute',
    paddingBottom: "".concat(theme.space.large, "px"),
    top: '100%'
  }, (0, _defineProperty2.default)(_ref2, align, 0), (0, _defineProperty2.default)(_ref2, "transition", 'opacity 500ms ease'), (0, _defineProperty2.default)(_ref2, "zIndex", 9999), _ref2;
});
exports.SubMenu = SubMenu;
var SubNavItem = (0, _theming.default)('li')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    opacity: 1,
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    whiteSpace: 'nowrap',
    marginTop: "".concat(theme.space.xsmall, "px")
  };
});
exports.SubNavItem = SubNavItem;